/**
 *   Generated file. Do not edit
 */

export const ResultCodeTranslation = {
  /**
   * OK
   * decimal: 0
   */
  0x0: 'The request was successful',

  /**
   * CREATED
   * decimal: 65
   */
  0x41: 'Create request was successful',

  /**
   * DELETED
   * decimal: 66
   */
  0x42: 'Delete request was successful',

  /**
   * CHANGED
   * decimal: 68
   */
  0x44: 'Update request was successful',

  /**
   * CONTENT
   * decimal: 69
   */
  0x45: 'The server has fulfilled the request and sent a response',

  /**
   * BUSY
   * decimal: 70
   */
  0x46: 'The server is busy',

  /**
   * BAD_REQUEST
   * decimal: 128
   */
  0x80: 'Bad request. Meaning device cannot understand your request.',

  /**
   * UNAUTHORIZED
   * decimal: 129
   */
  0x81: 'Current user is not authorized to access this ressource',

  /**
   * NOT_FOUND
   * decimal: 132
   */
  0x84: 'The server has not found anything matching the Request',

  /**
   * METHOD_NOT_ALLOWED
   * decimal: 133
   */
  0x85: 'Current user is not authorized to access this ressource',

  /**
   * NOT_ACCEPTABLE
   * decimal: 134
   */
  0x86: 'Given parameters are not acceptable',

  /**
   * RESOURCE_LOCKED
   * decimal: 135
   */
  0x87: 'Given resource is not available with the current TAP configuration.',

  /**
   * INTERNAL_SERVER_ERROR
   * decimal: 160
   */
  0xa0: 'Internal server error',

  /**
   * NOT_IMPLEMENTED
   * decimal: 161
   */
  0xa1: 'This resource has not been implemented yet',

  /**
   * SERVICE_UNAVAILABLE
   * decimal: 163
   */
  0xa3: 'Service is currently unavailable. Try again later.',

  /**
   * NVM_ERROR
   * decimal: 164
   */
  0xa4: 'Writing non volatible memory failed',

  /**
   * UNABLE_TO_CONNECT_TO_TARGET
   * decimal: 165
   */
  0xa5: 'Tap was not able to connect to the target',

  /**
   * TARGET_POWER_FAILURE
   * decimal: 166
   */
  0xa6: 'Target power failure',

  /**
   * NVM_FULL
   * decimal: 167
   */
  0xa7: 'Non volatile memory is full',

  /**
   * DEVICE_UNAVAILABLE
   * decimal: 168
   */
  0xa8: "It means we can't access this resource because someone is already connected to this device and he has the priority over us.",

  /**
   * RESPONSE_TOO_LARGE
   * decimal: 169
   */
  0xa9: 'Response is bigger than you current protocol limit',

  /**
   * TARGET_PROTOCOL_ERROR
   * decimal: 176
   */
  0xb0: 'Target protocol error',

  /**
   * TARGET_PROTOCOL_BUSY
   * decimal: 177
   */
  0xb1: 'Target protocol is busy',

  /**
   * TARGET_PROTOCOL_REAL
   * decimal: 178
   */
  0xb2: 'Target protocol error',

  /**
   * TARGET_PROTOCOL_WRONG_PARAM
   * decimal: 179
   */
  0xb3: 'Target protocol parameters are not valid',

  /**
   * TARGET_PROTOCOL_FORBIDDEN
   * decimal: 180
   */
  0xb4: 'Target protocol is forbidden',

  /**
   * TARGET_PROTOCOL_DATA
   * decimal: 181
   */
  0xb5: 'Target protocol data are not the one expected. For example a CRC error.',

  /**
   * TARGET_PROTOCOL_COM
   * decimal: 182
   */
  0xb6: 'Target protocol communication error',

  /**
   * TARGET_PROTOCOL_LOST_COM
   * decimal: 183
   */
  0xb7: 'Target protocol lost communication',

  /**
   * TARGET_PROTOCOL_PARAM
   * decimal: 184
   */
  0xb8: 'Target protocol invalid parameter',

  /**
   * TARGET_PROTOCOL_INT
   * decimal: 185
   */
  0xb9: 'Internal error with target communication',

  /**
   * TARGET_PROTOCOL_ABORT
   * decimal: 186
   */
  0xba: 'Operation aborted because one of the command did not return the expected result code.',

  /**
   * TARGET_PROTOCOL_NOT_IMPLEMENTED
   * decimal: 187
   */
  0xbb: 'Target protocol is not implemented',
};
